import { Controller } from "stimulus"

export default class extends Controller {
  static targets = [
    "date",
    "arr",
    "users",
    "splitLabel",
    "beforeRange",
    "afterRange",
    "afterArr",
    "afterUsers"
  ]

  static values = {
    periodStart: String,
    periodEnd: String,
    currentArr: Number,
    currentUsers: Number
  }

  connect() {
    this.update()
  }

  update() {
    const split = this.dateTarget.value
    const arr = this.numberValue(this.arrTarget.value)
    const users = this.numberValue(this.usersTarget.value)

    this.splitLabelTarget.textContent = split || "..."
    this.beforeRangeTarget.textContent = `${this.periodStartValue} → ${split ? this.dayBefore(split) : "..."}`
    this.afterRangeTarget.textContent = `${split || "..."} → ${this.periodEndValue}`
    this.afterArrTarget.textContent = `€ ${this.formatNumber(arr)}`
    this.afterUsersTarget.textContent = `${this.formatNumber(users)} users`

    this.afterArrTarget.classList.toggle("changed", arr !== this.currentArrValue)
    this.afterUsersTarget.classList.toggle("changed", users !== this.currentUsersValue)
  }

  numberValue(value) {
    if (value === "") return 0

    return Number.parseInt(value, 10) || 0
  }

  dayBefore(isoDate) {
    const date = new Date(`${isoDate}T00:00:00Z`)
    date.setUTCDate(date.getUTCDate() - 1)

    return date.toISOString().slice(0, 10)
  }

  formatNumber(value) {
    return new Intl.NumberFormat("nl-NL").format(value)
  }
}
